import React from 'react'
import { useState, useEffect} from 'react';
import { configData } from "../config";
import DatePicker from 'react-datepicker';
import { format } from "date-fns";
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import moment from 'moment-timezone';

moment.tz.setDefault('America/Los_Angeles')

const ViewUserProfile = ({uid,totalamount,userLoggedinDetails,userLoggedInRoles,userDetails,userAssets,userAthleteAssets,userMentorAssets,userAgentAssets,userScoutAssets,userAmbassadorAssets,userCommonAssets,userLeadAssets,userEventAssets,userSortflags,userRoles,productCount,agentscoutstatus}) => {
    const[coursesList, setCoursesList] = useState({});
    
    const[appliedcoursesList, setAppliedCoursesList] = useState({});
    const[salespersonList, setSalespersonList] = useState({});
    const[sameapplist, setSameappList] = useState({});
    
    const[selectedSalesperson, setselectedSalesperson] = useState('');
    const[selectedPriority, setselectedPriority] = useState('');
    const[showEventModal, setShowEventModal] = useState(false);
     const[showEventViewModal, setShowEventViewModal] = useState(false);
     const[showTaskModal, setShowTaskModal] = useState(false);
     const[showViewTaskModal, setShowViewTaskModal] = useState(false);
     const [isLoading, setIsLoading] = useState(true);
    const[success,setSuccess] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);
      const [loading, setLoading] = useState(false);
       const [open, setOpen] = useState(true);
      var currentdate = new Date().toLocaleDateString();
      const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
      const currentDatePST = moment().tz('America/Los_Angeles').format('MM-DD-YYYY');
       const currentDateTimePST = moment().tz('America/Los_Angeles').format('MM/DD/YYYY h:mm:ss A');
       const currentDateCustomTimePST = moment().tz('America/Los_Angeles').set({ hour: 1, minute: 0, second: 0 }).format('MM-DD-YYYY hh:mm:ss A');
    var currenttime = new Date().toLocaleTimeString();
    var currentdatetime = currentdate+' '+currenttime;
    
     const [eventformData, setEventFormData] = useState({
        loggedin_uid: localStorage.getItem('drupal_uid'),
        drupal_uid: uid,
        subject: 'Out Bound Call',
        details: ''
    });
   
    const [taskformData, setTaskFormData] = useState({
        loggedin_uid: localStorage.getItem('drupal_uid'),
        drupal_uid: uid,
        salesperson: localStorage.getItem('drupal_uid'),
        due_date: currentDateCustomTimePST,
        priority: 'Medium',
        repeat: '',
        frequency: '',
        spantype: 'Day',
        subject: '',
        details: '',
        apply_courses: '',
    });
     const [viewtaskformData, setViewTaskFormData] = useState({
        loggedin_uid: localStorage.getItem('drupal_uid'),
        drupal_uid: uid,
        id:'',
        salesperson: '',
        due_date: '',
        priority: 'Medium',
        repeat: '',
        frequency: '',
        spantype: 'Day',
        subject: '',
        details: '',
        apply_courses: '',
    });
     const [eventlist, setEventList] = useState({});
     const [eventdetailedview, setEventDetailedView] = useState({});
     const [taskdetailedview, setTaskDetailedView] = useState({});
     const [tasklist, setTaskList] = useState({});
    
     
    const app_url = configData.APP_URL;
  
    
    const handleModalOpen = (modalname) => {
        if(modalname == 'add_event_log') {
            setShowEventModal(true);
        }
        if(modalname == 'view_event_log') {
            setShowEventViewModal(true);
        }
        if(modalname == 'add_task') {
        setShowTaskModal(true);
        }
        
    };
    const handleViewModalOpen = async (modalname,eventid) => {
        if(modalname == 'add_event_log') {
            setShowEventModal(true);
        }
        if(modalname == 'view_event_log') {
            setShowEventViewModal(true);
          
            if(uid && !Number.isNaN(uid)) {
        
                try {
                const response =  await fetch(
                app_url+'smwweventlog/getusereventdetailedview?uid='+uid+'&eventid='+eventid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
                )
                const responsedata =  await response.json();
                
                if(responsedata.data.msg == "Success") {
                    
                    setEventDetailedView(responsedata.data.result);
                    
                } 
                } catch (err) {
                }
            }
        

        }
        if(modalname == 'view_task') {
        setShowViewTaskModal(true);
        if(uid && !Number.isNaN(uid)) {
        
                try {
                const response =  await fetch(
                app_url+'smwwtask/getusertaskdetailedview?uid='+uid+'&taskid='+eventid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
                )
                const responsedata =  await response.json();
                
                if(responsedata.data.msg == "Success") {
                    
                    setTaskDetailedView(responsedata.data.result);
                    setViewTaskFormData({ 
                      loggedin_uid: userLoggedinDetails.drupal_uid,
                      drupal_uid: uid,
                      id:responsedata.data.result.id,
                      salesperson: responsedata.data.result.field_assignee,
                      due_date: responsedata.data.result.field_due_date,
                      priority: responsedata.data.result.field_priority,
                      repeat: responsedata.data.result.field_repeat,
                      frequency: responsedata.data.result.field_frequency,
                      spantype: responsedata.data.result.field_frequency_type,
                      subject: responsedata.data.result.title,
                      details: responsedata.data.result.body,
                      apply_courses: responsedata.data.result.field_apply_courses,
                    });
                    
                } 
                } catch (err) {
                }
            }
        }
    };
    const handleModalClose = (modalname) => {
        if(modalname == 'add_event_log') {
        setShowEventModal(false);
        }
        if(modalname == 'view_event_log') {
        setShowEventViewModal(false);
        setEventDetailedView({});
        }
         if(modalname == 'add_task') {
        setShowTaskModal(false);
        }
        if(modalname == 'view_task') {
        setShowViewTaskModal(false);
        setTaskDetailedView({});
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        
        setEventFormData({ ...eventformData, [name]: value });
    };
    const handleTaskChange = (e) => {
        const { name, value } = e.target;
       
        setTaskFormData({ ...taskformData, [name]: value });
        console.log(taskformData);
    };
    const handleViewTaskChange = (e) => {
        const { name, value } = e.target;
       if(name == "salesperson") {
          setselectedSalesperson(value);
       }
       if(name == "priority") {
          setselectedPriority(value);
       }
       
        setViewTaskFormData({ ...viewtaskformData, [name]: value });
        console.log(taskformData);
    };
    const handleDateChange = (date) => {
   
    if (date) {
     const formattedDate = format(date, "MM-dd-yyyy h:mm:ss aa");
       setTaskFormData({ ...taskformData, ['due_date']: formattedDate });
      
      // You can now use formattedDate for your application logic
    }
  };
  const handleViewTaskDateChange = (date) => {
   
    if (date) {
      const formattedDate = format(date, "yyyy-MM-dd HH:mm:ss"); // Example: 2025-06-21 11:03:00
       setViewTaskFormData({ ...viewtaskformData, ['due_date']: formattedDate });
      
      // You can now use formattedDate for your application logic
    }
  };
  const handleInputChange = (event, newInputValue) => {
   
     setInputValue(newInputValue)
    // Handle the new input value as needed
  };
  const isPastDateTimeInPST = (dateTimeToCheck) => {
  // Get current datetime in PST
  const currentPST = moment.tz("America/Los_Angeles");
  
  // Parse and keep the datetime to check in PST for comparison
  const dateTimeToCheckPST = moment.tz(dateTimeToCheck, "America/Los_Angeles");
  
  return dateTimeToCheckPST.isBefore(currentPST);
};

    useEffect(() => {
      try {
        
    getcourselist();
   geteventlist();
   gettasklist();
    getsalespersonlist();
   getsameapplist();
    }catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
  },[]);
  useEffect(() => {
    const fetchSuggestions = async () => {
      if (inputValue.trim() === '') { // Only search if input is long enough
        setOptions([]);
        return;
      }

      setLoading(true);
      try {
          const response = await fetch(app_url+'viewprofile/getalluserlist?query='+inputValue);
        const data = await response.json();
        setOptions(data.data.result); // Assuming data is an array of objects for Autocomplete
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setOptions([]); // Clear options on error
      } finally {
        setLoading(false);
      }
    };

    const debounceTimeout = setTimeout(() => {
      fetchSuggestions();
    }, 500); // Debounce API calls

    return () => clearTimeout(debounceTimeout);
  }, [inputValue]);
  const renderOption = (props, option) => (
    <li {...props}>
     
        {option.label}
      
    </li> 
  );
  
  const getOptionLabel = (option) => option.label;
  
    async function getcourselist() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'viewprofile/getajaxcourselist?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setCoursesList(responsedata.data.result);
                setAppliedCoursesList(responsedata.data.applied_courses);
            } 
        } catch (err) {
            
         }
        }
  }
   async function getsalespersonlist() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'viewprofile/getsalespersonlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        }
  }
   async function getsameapplist() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'viewprofile/getsameapplist?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSameappList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        }
  }
  async function geteventlist() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'smwweventlog/getusereventlist?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
                setEventList(responsedata.data.result);
            } 
        } catch (err) {
            
         }
        }
  }
     async function gettasklist() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'smwwtask/getusertasklist?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
                setTaskList(responsedata.data.result);
            } 
        } catch (err) {
            
         }
        }
  }
   
    const handleAddCourse = async (value) => {
        const postData = {
            uid:uid,
            course_code:value
        };
        try {
            const response = await fetch(app_url + 'viewprofile/addcourse', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
               alert('Added Successfully');
               
               setAppliedCoursesList(data.data.applied_courses);
               geteventlist();
            }
            else if(data.data.msg === "Error") {
               alert(data.data.result);
               
            }
        } catch (err) {
            
        }
    };
    const handleDeleteCourse = async (value) => {
        const postData = {
            uid:uid,
            course_code:value
        };
        try {
            const response = await fetch(app_url + 'viewprofile/deletecourse', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
               alert('Deleted Successfully');
               setAppliedCoursesList(data.data.applied_courses);
               geteventlist();
            }
        } catch (err) {
            
        }
    };

    const handleSameAppChange = async (event, newValue) => {
      if(newValue.id == uid) {
       alert("This is the same user you are viewing - please add a different one.");
       setInputValue('');
       return false;

      }
     const postData = {
            uid:newValue.id,
            match_uid:uid,
            current_user:localStorage.getItem('drupal_uid')
        };
        try {
            const response = await fetch(app_url + 'viewprofile/addsameapp', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
               alert('Added Successfully');
               //window.location.reload();
               setSameappList(data.data.result);
               geteventlist();
            }
            if(data.data.msg === "Error") {
              alert(data.data.text);
            }
        } catch (err) {
            
        }
};
 const handleDeleteSameApp = async (id,match_uid,uid) => {
        const postData = {
            id:id,
            uid:uid,
            match_uid:match_uid,
            current_user:localStorage.getItem('drupal_uid')
        };
        try {
            const response = await fetch(app_url + 'viewprofile/deletesameapp', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
               alert('Deleted Successfully');
               getsameapplist();
              //setSameappList(data.data.result);
               geteventlist();
            }
        } catch (err) {
            
        }
    };

  const validate = (data) => {
  const newErrors = {};

  if(!data.subject.trim()) { 
    alert('Subject is required');
    
    newErrors.subject = 'Subject is required';
   
  }
   else if(!data.details.trim()) { 
    alert('Details is required');
    newErrors.details = 'Details is required';
    
  }

  return newErrors;
  };
  const addtaskvalidate = (data) => {
  const newErrors = {};

  if(!data.subject.trim()) { 
    alert('Event Title is required');
    
    newErrors.subject = 'Event Title is required';
   
  }
  else if(!data.due_date.trim()) { 
    alert('Due Date is required');
    
    newErrors.due_date = 'Due Date is required';
   
  }
  

  return newErrors;
  };
    const handleSubmit = async event => {
       //const formErrors = validate(eventformData);

      //if (Object.keys(formErrors).length == 0) {
        event.preventDefault();
        const postData = eventformData;
        const response = await fetch(app_url + 'smwweventlog/addevent', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
        const data = await response.json();
        if(data.data.msg == "Success") {
            setShowEventModal(false);
            setEventList(data.data.result);
            window.location.reload();
        }
      //}
    };
    const handleTaskSubmit = async event => {
      const formErrors = addtaskvalidate(taskformData);

      if (Object.keys(formErrors).length == 0) {
        event.preventDefault();
        const postData = taskformData;
        const response = await fetch(app_url + 'smwwtask/addtask', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
        const data = await response.json();
        if(data.data.msg == "Success") {
            setShowTaskModal(false);
            setTaskList(data.data.result);
        }
      }
    };
    const handleTaskComplete = async (value) => {

        const confirmed = window.confirm('Are you sure you want to mark this task as complete? This cannot be undone.');

          if (confirmed) {
           const postData = {
            uid:uid,
            id:value
          };
          try {
            const response = await fetch(app_url + 'smwwtask/completetask', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
               
               setTaskList(data.data.result);
            }
          } catch (err) {
            
        }
        } else {
          // User clicked "Cancel"
      
        }
       
    };
    const handleTaskCompleteWithouConfirm = async (value) => {
        const postData = {
            uid:uid,
            id:value
          };
          try {
            const response = await fetch(app_url + 'smwwtask/completetask', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
               
               setTaskList(data.data.result);
            }
          } catch (err) {
            
        }
       
       
    };
    const handleViewTaskSubmit = async (value) => {
       
        const postData = {
          formData: viewtaskformData,
          id: value
          };
        const response = await fetch(app_url + 'smwwtask/updatetask', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
        const data = await response.json();
        if(data.data.msg == "Success") {
            setShowViewTaskModal(false);
            setTaskList(data.data.result);
        }
    };
    return (
        <div className="page-view-myorder application-user-profile"> 
        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) && (
          <>
          <div className="panel panel-default">
                <div className="panel-heading" >
                    <b>Applied to the following Course(s):</b>
                </div>
                <div className="panel-body">
                    {appliedcoursesList.length > 0 && (
                        <>
                    {appliedcoursesList.map((item, index) => {
                 return <>
                     <a href="#" >{item['name']}</a> | <a href style={{'cursor':'pointer'}} onClick={() => handleDeleteCourse(item['code'])}>DELETE</a><br/>
                    </>
                    
                    })}  
                    </>
                )}
	 			</div>
            </div>

            <div className="panel panel-default">
                <div className="panel-heading">
                    
                    <b>Courses</b>
                </div>
                <div className="panel-body">
                    {coursesList.length > 0 && (
                        <>
                    {coursesList.map((item, index) => {
                 return <>
                    <a href onClick={() => handleAddCourse(item['course_code'])} style={{'cursor':'pointer'}}>{item['courses_special_code']}</a> |&nbsp;
                    </>
                    
                    })}  
                    </>
                )}
	            </div>
            </div>
	        
          
            <div class="aspect-tab profile_summary">
            <input id="item-20" type="checkbox" class="aspect-input" name="aspect" />
    <label for="item-20" class="aspect-label"></label>
    <div class="aspect-content">
        <div class="aspect-info">
           
            <span class="aspect-name"><strong>Profile Summary</strong></span> 
        </div>
        
    </div>

        <div class="aspect-tab-content">
        <div class="profile_summary_sentiment-wrapper">
          
				<div class="opinion-header profile_summary">
                    <table>
				        <tbody>
                            <tr>
                                <td valign="top" ><span class="user-profile-label">Created Date:&nbsp;</span>{userDetails.created_at}</td>
                                <td valign="top"><span class="user-profile-label">First Form Submitted:&nbsp;</span> 
			                    {userAssets['86'] && userAssets['86'].value}
                                </td>
                            </tr>
				            <tr>
                                <td valign="top"><span class="user-profile-label">Most Recent App:&nbsp;</span>{userCommonAssets.field_date_of_app}</td>
                                <td valign="top"><span class="user-profile-label">Last Form Submitted:&nbsp;</span>
                                {userAssets['87'] && userAssets['87'].value}</td>
                            </tr>
				            <tr>
                                <td  valign="top"><span class="user-profile-label"># of Courses Purchased:&nbsp;</span>{productCount.course}</td><td valign="top"><span class="user-profile-label"># of Conferences Purchased:&nbsp;</span>{productCount.conference}</td>
                            </tr>
				            <tr>
                                <td  valign="top"><span class="user-profile-label">{agentscoutstatus.agent}</span></td><td valign="top"><span class="user-profile-label">{agentscoutstatus.scout}</span></td>
                            </tr>
				            <tr>
                                <td valign="top"><span class="user-profile-label">Total Purchased:&nbsp;</span>{totalamount}</td>
                            </tr>
               
		                </tbody>
                    </table>
                </div>	
        </div>
    </div>
   
  </div><br/>
   <div class="aspect-tab profile_summary">
            <input id="item-21" type="checkbox" class="aspect-input" name="aspect" />
    <label for="item-21" class="aspect-label"></label>
    <div class="aspect-content">
        <div class="aspect-info">
           
            <span class="aspect-name"><strong>Same App</strong></span> 
        </div>
        
    </div>

        <div class="aspect-tab-content">
        <div class="profile_summary_sentiment-wrapper">
          
				<div class="opinion-header profile_summary">
                  <div>
                   
     <Autocomplete
     
                                     id="user_search"
                                     PopperProps={{
    disablePortal: false, // Ensure this is false (default) to use a portal
  }}
                                    options={options}  
                                    
                                    renderOption={renderOption}
                                    getOptionLabel={getOptionLabel}
                                    inputValue={inputValue}
                                    onInputChange={handleInputChange}
                                    onChange={handleSameAppChange}
                                    loading={loading} // Material UI Autocomplete has a built-in loading prop
                                
                                     renderInput={(params) => (
        <TextField
          {...params}
          label="Search"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
        
      )}
                                   /> <div className="same_app_list">
                                    {sameapplist.length > 0 && (
                        <>
                    {sameapplist.map((item, index) => {
                 return <>
                     <a href={"/user/"+item['drupal_uid']} >{item['name']}</a> | <a href style={{'cursor':'pointer'}} onClick={() => handleDeleteSameApp(item['id'],item['match_uid'],uid)}>DELETE</a><br/>
                    </>
                    
                    })}  
                    </>
                )}
                                   </div></div>
                </div>	
        </div>
    </div>
   
  </div><br/>
  </>
        )}
    <div>
      {userDetails.email && <p><b>Email Address<img src="/basic/web/images/mail-icon.gif"/>: </b> {userDetails.email}</p>
      }
      {userDetails.primary_phone && <p><b>Primary Phone: </b> {userDetails.primary_phone}</p>
      }
      {userDetails.street_address && <p><b>Street Address: </b> {userDetails.street_address}</p>
      }
      {userDetails.city && <p><b>City/Town: </b> {userDetails.city}</p>
      }
      {userDetails.state && <p><b>State/Province: </b> {userDetails.state}</p>
      }
      {userDetails.province && <p><b>Province: </b> {userDetails.province}</p>
      }
      {userDetails.country && <p><b>Country: </b> {userDetails.country}</p>
      }
       {userDetails.postal_code && <p><b>Zip/Postal Code: </b> {userDetails.postal_code}</p>
      }
      {userAssets && ( <>
        {userAssets.length > 0 && (
            <>
            {userAssets.map((item, index) => {
                return <>
                {item['key'] == "field_q_a" && item['value'] != null && item['value'] ? (
                    <><b>Q & A: </b><div style={{overflowWrap:'break-word'}} dangerouslySetInnerHTML={{ __html: item['value'] }}></div></>
                  ) :  (item['key'] == "field_biography") && item['value'] != null && item['value'] !== '' ? (
                    <><b>{item['label']}: </b><div style={{overflowWrap:'break-word'}} dangerouslySetInnerHTML={{ __html: item['value'] }}></div></>
                  ):  (item['key'] == "field_career_information") && item['value'] != null && item['value'] !== '' ? (
                    <><b>{item['label']}: </b><div style={{overflowWrap:'break-word'}} dangerouslySetInnerHTML={{ __html: item['value'] }}></div></>
                  ):  (item['key'] == "field_meta_description") && item['value'] != null && item['value'] !== '' ? (
                    <><b>{item['label']}: </b><div style={{overflowWrap:'break-word'}} dangerouslySetInnerHTML={{ __html: item['value'] }}></div></>
                  ):  (item['key'] == "field_how_to_contact_client") && item['value'] != null && item['value'] ? (
                    <><b>{item['label']}: </b><div style={{overflowWrap:'break-word'}} dangerouslySetInnerHTML={{ __html: item['value'] }}></div></>
                  ):  (item['key'] == "field_education" || item['key'] == "field_sports_you_worked" || item['key'] == "field_your_dream_job") && item['value'] != null && item['value'] ? (
                    <><b>{item['label']}: </b><div style={{overflowWrap:'break-word'}} dangerouslySetInnerHTML={{ __html: item['value'] }}></div></>
                  ):(item['key'] == "field_cuc_degrees") && item['value'] != null && item['value'] ? (
                    <><b  style={{ backgroundColor: '#FFFF00',color: '#000' }}>{item['label']}: </b><div dangerouslySetInnerHTML={{ __html: item['value'] }}></div></>
                  ):(item['key'] == "field_doc_talk") && item['value'] != null && item['value'] ? (
                    <><b>{item['label']}: </b><div dangerouslySetInnerHTML={{ __html: item['full_value'] }}></div></>
                  ):(item['key'] == "field_linkedin_url") && item['value'] != null && item['value'] ? (
                    <><b>{item['label']}: </b><div style={{overflowWrap:'break-word'}} dangerouslySetInnerHTML={{ __html: item['value'] }}></div></>
                  ):(item['key'] == "field_user_assignment") && item['value'] != null && item['value'] ? (
                    <><b>{item['label']}: </b><div dangerouslySetInnerHTML={{ __html: item['value'] }}></div></>
                  ) : (item['value'] != null && item['value'] && (
                    <><p style={{overflowWrap:'break-word'}}><b>{item['label']}: </b> {item['value']}</p></>
                  )
                )}
                </>
                    
            })}  
            
          </>
        )}
        </>)}
        {userAthleteAssets.length > 0 && (
            <>
            {userAthleteAssets.map((item, index) => (
                 <>
                 {(item['key'] == "field_athlete_contract" && item['value'] != null && item['value'] !== '') ? (
                    <><p><b>Athlete Contract: </b><div dangerouslySetInnerHTML={{ __html: item['value'] }}></div></p></>
                  ): (item['key'] == "field_signing_agent_id" && item['value'] != null && item['value'] !== '') ? (
                    <><p><b>{item['label']}: </b><div dangerouslySetInnerHTML={{ __html: item['full_value'] }}></div></p></>
                  ): (item['key'] == "field_current_agent_id" && item['value'] != null && item['value'] !== '') ? (
                    <><p><b>{item['label']}: </b><div dangerouslySetInnerHTML={{ __html: item['full_value'] }}></div></p></>
                  ): (item['key'] == "field_agents_represented_by" && item['value'] != null && item['value'] !== '') ? (
                    <><p><b>{item['label']}: </b><div dangerouslySetInnerHTML={{ __html: item['full_value'] }}></div></p></>
                  ): (item['key'] == "field_how_to_contact_client" && item['value'] != null && item['value'] !== '') ? (
                    <><p><b>{item['label']}: </b><div dangerouslySetInnerHTML={{ __html: item['value'] }}></div></p></>
                  ): (item['key'] == "field_athlete_sports" && item['value'] != null && item['value'] !== '') ? (
                    <><p><b>{item['label']}: </b>{item['full_value']}</p></>
                  ): item['value'] != null && item['value'] ? (
                    <p><b>{item['label']}: </b>{item['value']}</p>
                  ) : null}
              
                </>
                    
            ))}  
           
          </> 
        )}
           {userAgentAssets.length > 0 && (
            <>
            {userAgentAssets.map((item, index) =>  (
                 <>
                  {item['key'] == "field_show_on_frontend_agent" && userRoles.includes(configData.ROLE_AGENT) ? (
                    <p><b>{item['label']}: </b>{item['full_value']}</p>
                  ) : (item['key'] == "field_agent_photo" && item['value'] != null && item['value'] !== '') ? (
                    <><p><b>{item['label']}: </b><br/><img src={item['value']}></img></p></>
                  ) : (item['key'] == "field_agent_contract" && item['value'] != null && item['value'] !== '') ? (
                    <><p><b>Agent Contract: </b><div dangerouslySetInnerHTML={{ __html: item['value'] }}></div></p></>
                  ): ((item['key'] == "field_agent_sports" || item['key'] == "field_agent_certifications" || item['key'] == "field_special_certifications") && item['value'] != null && item['value'] !== '') ? (
                    <><p><b>{item['label']}: </b>{item['full_value']}</p></>
                  ) : (item['key'] == "field_agent_biography"  && item['value'] != null && item['value'] !== '') ? (
                    <><b>{item['label']}: </b><div style={{overflowWrap:'break-word'}} dangerouslySetInnerHTML={{ __html: item['value'] }}></div></>
                  ) : item['value'] != null && item['value'] ? (
                    <p><b>{item['label']}: </b>{item['value']}</p>
                  ) : null}
               
                </>
                    
            ))}  
           
          </>
        )}
         {userScoutAssets.length > 0 && (
            <>
            {userScoutAssets.map((item, index) => (
                
                  <>
                  {item['key'] == "field_show_on_frontend_scout" && userRoles.includes(configData.ROLE_SCOUT) ? (
                    <p><b>{item['label']}: </b>{item['full_value']}</p>
                  ) : ( item['key'] == "field_scout_photo" && item['value'] != null && item['value'] !== '') ? (
                    <><p><b>{item['label']}: </b><br/><img src={item['value']}></img></p></>
                  ) : (item['key'] == "field_scout_contract" && item['value'] != null && item['value'] !== '') ? (
                    <><p><b>Scout Contract: </b><div dangerouslySetInnerHTML={{ __html: item['value'] }}></div></p></>
                  ) :  (item['key'] == "field_scout_sport" && item['value'] != null && item['value'] !== '') ? (
                    <><p><b>{item['label']}: </b>{item['full_value']}</p></>
                  ) : (item['key'] == "field_scout_biography"  && item['value'] != null && item['value'] !== '') ? (
                    <><b>{item['label']}: </b><div style={{overflowWrap:'break-word'}} dangerouslySetInnerHTML={{ __html: item['value'] }}></div></>
                    ) : item['value'] != null && item['value'] ? (
                    <p><b>{item['label']}: </b>{item['value']}</p>
                  ) : null}
              
                </>
               ))}  
           
          </>
        )}
           
         
         {userMentorAssets.length > 0 && (
            <>
            {userMentorAssets.map((item, index) => {
                return <>
                {item['value'] != null && item['value'] && (
                  <>
                  {item['key'] == "field_mentor_photo" ? (
                    <><p><b>{item['label']}: </b><br/><img src={item['value']}></img></p></>
                  )  : (item['key'] == "field_mentor_biography" && item['value']) ? (
                    <><b>{item['label']}: </b><div style={{overflowWrap:'break-word'}} dangerouslySetInnerHTML={{ __html: item['value'] }}></div></>
                  ) : (item['value'] != null && item['value'] && (
                    
                    <p><b>{item['label']}: </b>{item['value']}</p>
                  )
                  )
                }
                </>
                )}
                </>
                    
            })}  
           
          </>
        )}
       {userAmbassadorAssets.length > 0 && (
    <>
      {userAmbassadorAssets.map((item, index) => (
        <>
          {item['key'] == "field_show_on_frontend_ambassado" && userRoles.includes(configData.ROLE_GLOBAL_AMBASSADOR) ? (
            <p><b>{item['label']}: </b>{item['full_value']}</p>
          ) : item['key'] == "field_sports_focus" && item['value'] ? (
            <p><b>{item['label']}: </b>{item['full_value']}</p>
          ) : item['key'] == "field_q_a" ? (
            <div dangerouslySetInnerHTML={{ __html: item['value'] }}></div>
          ) : item['value'] != null && item['value'] ? (
            <p><b>{item['label']}: </b>{item['value']}</p>
          ) : null}
        </>
      ))}
    </>
  )
}
{userLeadAssets.length > 0 && (
    <>
      {userLeadAssets.map((item, index) => (
        <>
          {(item['key'] == "field_lead_type" || item['key'] == "field_lead_sort_flag") && item['value'] != null ? (
            <p><b>{item['label']}: </b>{item['full_value']}</p>
          )  : item['value'] != null && item['value'] ? (
            <p><b>{item['label']}: </b>{item['value']}</p>
          ) : null}
        </>
      ))}
    </>
  )
}
{userEventAssets.length > 0 && (
    <>
      {userEventAssets.map((item, index) => (
        <>
          {(item['value'] != null && item['value']) ? (
            <p><b>{item['label']}: </b>{item['value']}</p>
          ) : null}
        </>
      ))}
    </>
  )
}
      
         {userSortflags.length > 0 && (
            <><p><b>SortFlags:</b></p><ul className="sortflags_list">
            {userSortflags.map((item, index) => {
                return <>
                {item['name'] != null && (
                    <><li style={{'list-style':'disc'}}><a target="_blank" href={"/sort-flag-users/"+item['tid']}>{item['name']}</a></li></>
                )}
                </>
                    
            })}  
            </ul>
          </>
        )}
    </div>
          {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) && (
          <>
        <table id="event_logs_js" className="EventLog white"  border="0" cellpadding="2"  cellspacing="0">
        <tbody>
            <tr valign="top" >
                <td height="17" colspan="4" valign="top" align="left" class="infobar"><span>&nbsp;<b>Event Log</b> 20 Most Recent</span>&nbsp;&nbsp;<a href={"/eventlog/more/"+uid} target="_blank" style={{'color':'#2C99D2'}}>More</a></td>
                <td align="right" class="infobar outbound_image">
                    <a href onClick={() => handleModalOpen('add_event_log')} style={{'cursor':'pointer'}} title="Event Log" class="thickbox"><img src="/basic/web/images/outboundcall.gif" alt="Out Bound Call" title="Out Bound Call" border="0" align="top"/></a>
                </td>
            </tr>
           
               <tr style={{'background-color':'#CCCCCC' }} valign="top">
                <td>&nbsp;</td><td><b>Date</b></td><td><b>Who</b></td><td><b>Subject</b></td><td><b>Details</b></td>
            </tr>
               
             {eventlist.length > 0 ? (
            <>
            {eventlist.map((item, index) => {
                return <>
               <tr valign="top">
                <td><img src="/basic/web/images/viewlog.gif" style={{'cursor':'pointer'}} onClick={() => handleViewModalOpen('view_event_log',item['event_id'])}/></td><td>{item['date']}</td><td>{item['who']}</td><td>{item['subject']}</td><td dangerouslySetInnerHTML={{ __html: item['details'] }}></td>
            </tr>
                </>
                    
            })}  
            </>
            ) : (
                <><tr id="no_events"><td colspan="5"><b>There are no events associated to this record</b></td></tr></>
            )}
            
        </tbody>
        </table><br/>
        
           
                <table id="task_result" width="382" border="0" cellpadding="0" class="white" cellspacing="0">
                  <tbody><tr>
                    <td height="17" colspan="8" valign="top" align="left" class="infobar"><span>&nbsp;<b>Scheduled Tasks</b>10 Most Recent</span>&nbsp;&nbsp;<a href={"/moretasks/"+uid} style={{'color':'#2C99D2'}}  target="_blank">More</a>
					
                    					</td>
                    <td align="right" class="infobar desktop_add_task">
                                            <a href style={{'cursor':'pointer'}} onClick={() => handleModalOpen('add_task')} title="Add Task" class="thickbox">
                          <img src="/basic/web/images/newTask.gif" alt="Create New Task" border="0" /></a>&nbsp;
                                        </td>
                  </tr>
                  <tr bgcolor="CCCCCC">
                    <td width="30">&nbsp;</td>
                    <td width="70"><b>Created</b></td>
                    <td><b>Sales Person</b></td>
                    <td width="70"><b>Due Date</b></td>
                    <td width="60"><b>Priority</b></td>
                    <td><b>Who</b></td>
                    <td><b>Acct</b></td>
                   
                    <td width=""><b>Subject</b></td>
                    
                    <td width="30">&nbsp;</td>
                  </tr>
                  
                  {tasklist.length > 0 ? (
                    <>
                      {tasklist.map((item, index) => {

                        const isPast = isPastDateTimeInPST(item['field_due_date']);
                       
                        return <>
                          <tr bgcolor={item['bg_color']}>
                             {isPast ? (
                              <td><a href style={{'cursor':'pointer'}} onClick={() => handleTaskCompleteWithouConfirm(item['id'])} title="Mark Complate"><img src="/basic/web/images/markascomplete.gif" alt="Mark as Complete" border="0" /></a></td>
                             ):(

                               <td><a href style={{'cursor':'pointer'}} onClick={() => handleTaskComplete(item['id'])} title="Mark Complate"><img src="/basic/web/images/markascomplete.gif" alt="Mark as Complete" border="0" /></a></td>
                             )
                            }
                            <td>{item['created']}</td>
                            <td><a style={{'cursor':'pointer'}} href={"/user/"+item['field_assignee_uid']}>{item['field_assignee']}</a></td>
                            <td>{item['field_due_date']}</td>
                            <td>{item['field_priority']}</td>
                            <td>{item['who']}</td>
                            <td><a href style={{'cursor':'pointer'}} onClick={() => handleModalOpen('add_event_log')} title="Event Log" class="thickbox"><img src="/basic/web/images/outboundcall.gif" alt="Out Bound Call" title="Out Bound Call" border="0" align="top" /></a>
                                {userLoggedInRoles.includes(configData.ROLE_AGENT) && userRoles.includes(configData.ROLE_ATHLETE) ? (
                                <a style={{'cursor':'pointer'}} href={"/view_athlete/"+uid}><img src="/basic/web/images/ViewOwnerProfile.gif" alt="View Profile" border="0" align="top" />&nbsp;{item['owner']}</a>
                                ): (
                                  <a style={{'cursor':'pointer'}} href={"/user/"+uid}><img src="/basic/web/images/ViewOwnerProfile.gif" alt="View Profile" border="0" align="top" />&nbsp;{item['owner']}</a>
                                )}
                                </td>
                            <td><a href onClick={() => handleViewModalOpen('view_task',item['id'])} title="View Task" class="thickbox"><img src="/basic/web/images/viewtaskdetails.gif" alt="View Task Details" border="0" align="top" />{item['title']}</a></td>
                            <td align="right" width="25">&nbsp;</td>
                            
                          </tr>
                        </>
                    
                      })}  
                    </>
                  ) : (
                      <><tr id="no_events"><td colspan="10"><b>There are no pending items in your task schedule</b></td></tr></>
                  )}
                                            
                        </tbody></table></>
          )}
              
  {showEventModal && (           
<div id="myModal" class="modal add-event-modal">

 
  <div class="modal-content">
    <div class="modal-header">
      
      <h2>Add Event Log</h2>
      <span class="close"  style={{'cursor':'pointer'}} onClick={() => handleModalClose('add_event_log')}>&times;</span>
    </div>
    <div class="modal-body">
      <form id="athlete_eventlog" method="post">
       
        <p>
  Entering event for: <strong>{userDetails.first_name+' '+userDetails.last_name}</strong><br />
	By User: <strong>{userLoggedinDetails.first_name+' '+userLoggedinDetails.last_name}</strong><br />
	Start Time:{currentDateTimePST}</p>
<p>
	<strong>Subject:</strong>
	<input type="text" name="subject" defaultValue="Out Bound Call" onChange={handleChange} />
</p>
<p>
	<strong>Details:</strong>
	<textarea name="details" cols="40" rows="7" onChange={handleChange} ></textarea>
</p>
<p>
	
	<input type="button" id="btn" name="btn" value="Save" onClick={handleSubmit}/>
</p>
</form>
    </div>
    <div class="modal-footer">
     
    </div>
  </div>

</div>
  )}

  
   {showEventViewModal && (           
<div id="myModal view-event-log" class="modal view-event-modal">

 
  <div class="modal-content">
    <div class="modal-header">
      
      <h2>View Event Log</h2>
      <span class="close" onClick={() => handleModalClose('view_event_log')}>&times;</span>
    </div>
    <div class="modal-body">
        <table id="view-evenglog">
        <tbody>
        <tr>
            
            <td>EventID: <strong>{eventdetailedview.EventID}</strong></td>
            <td>Entered By: <strong>{eventdetailedview.EnteredBy}</strong>
            
            </td>
        </tr>
  
        <tr>
            <td>Event Date: <strong>{eventdetailedview.EventDate}</strong></td>
        </tr>
        <tr>
            <td>Bound To: <strong>{eventdetailedview.drupal_uid}</strong></td>
        </tr>
        <tr>
            <td>Subject: <strong>{eventdetailedview.Subject}</strong></td>
        </tr>
        <tr>
            <td>Details: <strong dangerouslySetInnerHTML={{ __html: eventdetailedview.Details }}></strong></td>
        </tr>
        </tbody>
        </table>
    </div>
   
  </div>

</div>
  )}

  {showTaskModal && (           
  <div id="myModal" className="modal addtask">
    <div className="modal-content">
      <div class="modal-header">
        
        <h2>Add Task</h2>
        <span class="close"  onClick={() => handleModalClose('add_task')}>&times;</span>
      </div>
      <div class="modal-body">
        <form id="task-add" method="post">
          <table id="add-task-table">
            <tbody><tr><td>Sales Person:</td>
              <td>
              <select id="salesperson" name="salesperson" value={taskformData.salesperson} onChange={handleTaskChange}>
                <option value="0"></option>
                {salespersonList.length > 0 && (
                <>
                  {salespersonList.map((item, index) => {
                    return <>
                      {item['uid'] != null && (
                        <><option value={item['uid']}>{item['name']}</option></>
                      )}
                    </>
                    
                  })}  
           
                </>
                )}
              </select>
              </td>
            </tr>
          <tr>
            <td><strong>Due Date:</strong></td>
	          <td>
              <DatePicker
                    id="datetime"
                    selected={taskformData.due_date ? new Date(taskformData.due_date) : null}
                    onChange={handleDateChange}
                    placeholderText=""
                    dateFormat="MM-dd-yyyy h:mm aa"
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={1}
                    className="form-input"
                  />
              </td>
          </tr>
          <tr>
	          <td><strong>Priority:</strong></td>
	          <td><select name="priority" value={taskformData.priority} onChange={handleTaskChange}>
		          <option value="High">High</option>
		          <option value="Medium" selected="">Medium</option>
		          <option value="Low">Low</option>
	          </select></td>
          </tr>
          {/*
          <tr>
	          <td><strong>Recurrence:</strong></td>
	          <td><input type="checkbox" name="repeat" id="repeat" value="1" onChange={handleTaskChange}/>
	          <label for="repeat" >Repeat</label>
	          <input type="text" name="frequency" defaultValue="1" size="3" maxlength="1" onChange={handleTaskChange}/>
	          times per
	          <select name="spantype" onChange={handleTaskChange}>
		          <option value="Day">Day</option>
		          <option value="Week">Week</option>
		          <option value="Month">Month</option>
		          <option value="Year">Year</option>
	          </select>
            </td>
          </tr>
          */}
          <tr>
	          <td><strong>Event Title:</strong></td>
	          <td><input type="text" name="subject" id="subject" onChange={handleTaskChange}/></td>
          </tr>
          <tr>
	          <td ><strong>Details:</strong></td>
	          <td><textarea name="details" cols="40" rows="7" onChange={handleTaskChange}></textarea></td>
          </tr>
          <tr>
            <td>Course/Conference:</td>
            <td><textarea name="apply_courses" cols="40" rows="3" onChange={handleTaskChange}></textarea></td>
          </tr>
          <tr>
            <td> </td><td>
              <input type="button" id="btn" name="btn" value="Save" onClick={handleTaskSubmit}/>
            </td>
          </tr>
        </tbody>
        </table>
        </form>
    </div>
    <div class="modal-footer">
     
    </div>
  </div>

</div>
  )}

  {showViewTaskModal && (           
  <div id="myModal" className="modal viewtask">
    <div class="modal-content">
      <div class="modal-header">
       
        <h2>View Task</h2>
         <span class="close"  onClick={() => handleModalClose('view_task')}>&times;</span>
      </div>
      <div class="modal-body">
        <form id="task-add" method="post">
          <table id="add-task-table">
            <tbody>
              <tr><td>Scheduled task bound to:</td><td>{taskdetailedview.field_owner_ac_target_id}</td></tr>
              <tr><td>Created:</td><td>{taskdetailedview.created_at}</td></tr>
              <tr><td>By User:</td><td>{taskdetailedview.uid}</td></tr>
              <tr><td>Sales Person:</td>
              <td>
              <select id="salesperson" name="salesperson" onChange={handleViewTaskChange} value={viewtaskformData.salesperson}>
                <option value="0"></option>
                {salespersonList.length > 0 && (
                <>
                  {salespersonList.map((item, index) => {
                    return <>
                      {item['uid'] != null && (
                        <><option value={item['uid']}>{item['name']}</option></>
                      )}
                    </>
                    
                  })}  
           
                </>
                )}
              </select>
              </td>
            </tr>
          <tr>
            <td><strong>Due Date:</strong></td>
	          <td>
              <DatePicker
                    id="datetime"
                    selected={viewtaskformData.due_date ? new Date(viewtaskformData.due_date) : null}
                    onChange={handleViewTaskDateChange}
                    placeholderText=""
                    dateFormat="MM-d-yyyy h:mm aa"
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={1}
                    className="form-input"
                    defaultValue={viewtaskformData.field_due_date}
                  />
              </td>
          </tr>
          <tr>
	          <td><strong>Priority:</strong></td>
	          <td><select name="priority" value={viewtaskformData.priority} onChange={handleViewTaskChange} >
		          <option value="High">High</option>
		          <option value="Medium" selected="">Medium</option>
		          <option value="Low">Low</option>
	          </select></td>
          </tr>
          {/*
          <tr>
	          <td><strong>Recurrence:</strong></td>
	          <td><input type="checkbox" name="repeat" id="repeat"  onChange={handleViewTaskChange} defaultValue={taskdetailedview.field_repeat}/>
	          <label for="repeat" >Repeat</label>
	          <input type="text" name="frequency" defaultValue="1" size="3" maxlength="1" onChange={handleViewTaskChange}/>
	          times per
	          <select name="spantype" defaultValue={taskdetailedview.field_frequency_type} onChange={handleViewTaskChange}>
		          <option value="Day">Day</option>
		          <option value="Week">Week</option>
		          <option value="Month">Month</option>
		          <option value="Year">Year</option>
	          </select>
            </td>
          </tr>
          */}
          <tr>
	          <td><strong>Event Title:</strong></td>
	          <td><input type="text" name="subject" defaultValue={viewtaskformData.subject} id="subject" onChange={handleViewTaskChange}/></td>
          </tr>
          <tr>
	          <td ><strong>Details:</strong></td>
	          <td><textarea name="details" cols="40" rows="7" defaultValue={viewtaskformData.details} onChange={handleViewTaskChange}></textarea></td>
          </tr>
          <tr>
            <td>Course/Conference:</td>
            <td><textarea name="apply_courses" cols="40" rows="3" defaultValue={viewtaskformData.apply_courses} onChange={handleViewTaskChange}></textarea></td>
          </tr>
          <tr>
            <td> </td><td>
              <input type="button" id="btn" name="btn" value="Save" onClick={()=>handleViewTaskSubmit(taskdetailedview.id)}/>
            </td>
          </tr>
        </tbody>
        </table>
        </form>
    </div>
    <div class="modal-footer">
     
    </div>
  </div>

</div>
  )}
    </div>

        
     )}

export default ViewUserProfile